import $ from 'jquery';
import BasePropertyView from 'BasePropertyView'
import formatTemplate from 'properties/style/signature_button_background.ejs';
import themeService from 'ThemeService';
import { pickerCfg } from 'pickerCfg';

class StyleSignatureButtonBackgroundView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes',
            'change #buttonFontSize': 'updateAttributes',
            'keydown #buttonBackgroundGradientColor': 'keyAction'
        };
        // Add needed property
        if (!this.model.get('buttonBackgroundColor')) {
            this.model.set('buttonBackgroundColor', '#EEEEEE', { silent: true });
        }

        if (!this.model.get('buttonBackgroundGradientColor')) {
            this.model.set('buttonBackgroundGradientColor', '#EEEEEE', { silent: true });
        }

        if (!this.model.get('buttonFontSize')) {
            this.model.set('buttonFontSize', '~buttonFont', { silent: true });
        }

        return this;
    }

    keyAction(ev) {
        var code = ev.keyCode || ev.which;
        if (code === 13) {
            ev.preventDefault();
        }
    }

    render() {
        super.render();
        let props = this.resolveThemeColors(this.model, ['buttonBackgroundColor', 'buttonBackgroundGradientColor','buttonFontSize']);
        this.$el.html(this.template(props));
        this.updateForm();
        this.delegateEvents();
        return this;
    }


    updateForm() {
        if (this.model.get('buttonFontSize')) {
            try{
                var fontSize=this.model.get('buttonFontSize');
                fontSize=  (fontSize.lastIndexOf("~") >=0  ?
                    themeService.getValueFromTheme(this.model.get('buttonFontSize'), 'fontSize'):this.model.get('buttonFontSize'));

                const q = `option[value="${fontSize}"]`;
                $('#buttonFontSize').find(q).attr('selected', true);

            }catch(error){
            }
        }
    }


}

export default StyleSignatureButtonBackgroundView;